var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNextArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 10 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.456 10.993L.528 17.86A1.73 1.73 0 0 0 0 19.139c0 .504.176.93.528 1.278l1.069 1.06c.351.349.781.523 1.29.523.508 0 .938-.174 1.29-.523l9.295-9.198c.352-.349.528-.775.528-1.279 0-.504-.176-.93-.528-1.279L4.177.523A1.764 1.764 0 0 0 2.887 0c-.509 0-.939.174-1.29.523l-1.07 1.06A1.721 1.721 0 0 0 0 2.854c0 .5.176.928.528 1.286l6.928 6.853z",
  fill: "#FFF",
  fillRule: "nonzero"
})));
export default SvgNextArrow;